module.exports = __webpack_public_path__ + "static/media/illustration-full.23a2ae01.png";